/**
 * ToolBar — Map tool activation panel
 *
 * Fixed-position toolbar on the right side of the map, below zoom controls.
 * Provides toggle buttons for waypoint placement and measurement tools.
 */

import React from 'react'

/**
 * ToolBar component.
 *
 * @param {Object} props
 * @param {'waypoint'|'measure'|'elevation'|null} props.activeTool - Currently active tool
 * @param {function} props.onToolChange - Callback with tool name or null to toggle
 */
export default function ToolBar({ activeTool, onToolChange }) {
  const handleClick = (tool) => {
    // Toggle: clicking the active tool deactivates it
    onToolChange(activeTool === tool ? null : tool)
  }

  return (
    <div className="toolbar" data-testid="toolbar">
      <button
        className={`toolbar-btn ${activeTool === 'waypoint' ? 'toolbar-btn-active' : ''}`}
        onClick={() => handleClick('waypoint')}
        title="Add Waypoint"
        type="button"
        data-testid="toolbar-btn-waypoint"
      >
        {/* Crosshair icon — Unicode */}
        <span className="toolbar-btn-icon">&#x271B;</span>
      </button>
      <button
        className={`toolbar-btn ${activeTool === 'measure' ? 'toolbar-btn-active' : ''}`}
        onClick={() => handleClick('measure')}
        title="Measure Distance"
        type="button"
        data-testid="toolbar-btn-measure"
      >
        {/* Ruler icon — Unicode straight ruler */}
        <span className="toolbar-btn-icon">&#x1F4CF;</span>
      </button>
      <button
        className={`toolbar-btn ${activeTool === 'elevation' ? 'toolbar-btn-active' : ''}`}
        onClick={() => handleClick('elevation')}
        title="Elevation Profile"
        type="button"
        data-testid="toolbar-btn-elevation"
      >
        {/* Mountain icon — Unicode */}
        <span className="toolbar-btn-icon">&#x25B2;</span>
      </button>
    </div>
  )
}
